function ReligiousFunctions() {
  return (
    <div>
      <div className="pt-16 px-4 md:px-8 lg:px-16 max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center md:text-left">
          देणगी सहकार्य
        </h2>
        <p className="text-gray-700 text-base md:text-lg leading-relaxed">
          श्री शिव शंभो चॅरिटेबल ट्रस्ट (श्री शिव शंभो महादेव मंदिर) यांच्या
          धार्मिक व सामाजिक उपक्रमांसाठी आपली देणगी अत्यंत मोलाची ठरते. आपल्या
          जनगीतून मंदिर विकास, अन्नदान, विविध धार्मिक कार्यक्रम तसेच समाजसेवेचे
          उपक्रम प्रभावीपणे राबवले जातात.
        </p>
      </div>
    </div>
  );
}

export default ReligiousFunctions;
